import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconClick = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Ellipse 57 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.27202 2.74396C5.74119 2.77471 6.19071 2.9439 6.56373 3.23013C6.93675 3.51636 7.21652 3.90677 7.36766 4.352C7.43463 4.54931 7.32898 4.76355 7.13167 4.83053C6.93436 4.89751 6.72012 4.79185 6.65314 4.59455C6.54998 4.29064 6.35901 4.02414 6.10439 3.82876C5.84977 3.63338 5.54293 3.5179 5.22267 3.49691C4.90241 3.47592 4.58312 3.55036 4.30518 3.71084C4.02723 3.87131 3.80312 4.1106 3.66117 4.39844C3.51922 4.68629 3.46581 5.00976 3.5077 5.32796C3.54959 5.64616 3.6849 5.94479 3.89651 6.18609C4.10813 6.42738 4.38654 6.60051 4.69655 6.68358C4.89781 6.73751 5.01725 6.94439 4.96333 7.14565C4.9094 7.34692 4.70252 7.46636 4.50125 7.41243C4.04709 7.29074 3.63922 7.0371 3.3292 6.6836C3.01919 6.3301 2.82097 5.89261 2.7596 5.42645C2.69823 4.96029 2.77646 4.4864 2.98442 4.06471C3.19238 3.64302 3.52071 3.29246 3.9279 3.05737C4.33509 2.82228 4.80285 2.71321 5.27202 2.74396Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Ellipse 58 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.83076 1.37069C5.56308 1.32269 6.29318 1.49293 6.92875 1.85987C7.56432 2.22682 8.0768 2.77399 8.40139 3.4322C8.55806 3.74989 8.66757 4.08658 8.72816 4.43172C8.76419 4.63695 8.62703 4.83253 8.4218 4.86856C8.21657 4.90459 8.021 4.76743 7.98497 4.5622C7.93669 4.28724 7.84946 4.01903 7.72465 3.76593C7.46606 3.24157 7.05779 2.80567 6.55147 2.51334C6.04515 2.22102 5.46351 2.0854 4.88011 2.12364C4.29671 2.16187 3.73775 2.37225 3.27391 2.72816C2.81008 3.08408 2.4622 3.56954 2.27427 4.12317C2.08634 4.67679 2.0668 5.27371 2.21812 5.83844C2.36944 6.40317 2.68482 6.91035 3.12438 7.29584C3.56395 7.68132 4.10795 7.92781 4.6876 8.00412C4.89418 8.03132 5.03961 8.22083 5.01241 8.42742C4.98521 8.634 4.79569 8.77942 4.58911 8.75223C3.8615 8.65643 3.17863 8.34703 2.62687 7.86315C2.0751 7.37926 1.67921 6.74262 1.48927 6.03374C1.29932 5.32485 1.32385 4.57556 1.55975 3.88062C1.79565 3.18568 2.23233 2.5763 2.81457 2.12953C3.3968 1.68277 4.09844 1.41869 4.83076 1.37069Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Vector 230 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.08749 6.58442C4.74638 5.65205 5.6516 4.74682 6.58398 5.08793L13.4512 7.60033C14.4111 7.95153 14.4874 9.27978 13.5739 9.73854L11.0698 10.9962C11.0378 11.0122 11.0118 11.0382 10.9957 11.0703L9.7381 13.5744C9.27934 14.4878 7.95109 14.4116 7.59988 13.4516L5.08749 6.58442Z",
			fill: "#60A5FA"
		})
	]
});
export default SvgIconClick;
